import React from 'react';
import './BoardNotification.css';

interface BoardNotificationProps {
    message: string;
    visible: boolean;
}

export function BoardNotification({ message, visible }: BoardNotificationProps) {
    if (!visible || !message) return null;

    return (
        <div className="board-notification-container">
            <div className="board-notification">
                {message}
            </div>
        </div>
    );
}
